/* global Profile, Forms */

import 'lib/remote_links'
import EditableText from 'components/EditableText'
import { createRoot } from 'react-dom/client'

window.Profile = {}

Profile.initEditable = function () {
  // This classes puts from users profile templates
  $('.react-editor').each((i, element) => {
    const root = createRoot(element)
    root.render(
      <EditableText text={Helpers.getEditorContent(element)} simplifiedButtons='true' type='editor' />
    )
  })

  // This classes comes from users profile templates
  $('.react-string').each((i, element) => {
    const root = createRoot(element)
    root.render(
      <EditableText text={$(element).text().trim()} type='string' />
    )
  })

  $('.remove_fields').on('click', function () {
    this.parentElement.remove()
  })

  $('.profile-row').on('mouseenter', function () {
    $(this).find('.remove_fields').show()
  }).on('mouseleave', function () {
    $(this).find('.remove_fields').hide()
  })

  Profile.initEditableActivePosition()
  Profile.closeEditablesBeforeSaveHTML()
  Profile.initCheckboxPerformance()
}

Profile.initEditableActivePosition = function () {
  $('.editable-active-position').each((i, element) => {
    $(element)
      .editable({ unsavedclass: '' })
      .on('save', function (e, editable) {
        $(element).attr('data-value', editable.newValue)
      })
  })
}

Profile.initSnapshotsForm = function () {
  const formElement = $('#profile_snapshot_form')

  Forms.initCheckbox(formElement)

  formElement.on('submit', () => {
    const currentProfileHTML = $('#rendered-profile').html()
    $('#profile_snapshot_content').val(currentProfileHTML)
  })
}

Profile.initCheckboxPerformance = function () {
  $('#rendered-profile input:checkbox, #rendered-profile input:radio').on('change', function (e) {
    const input = $(e.target)
    const name = e.target.name
    $(`input[name="${name}"]`).attr('checked', false)
    input.attr('checked', e.target.checked)
  })
}

Profile.closeEditablesBeforeSaveHTML = function () {
  $(document).off('click.profileSnapshotSubmit')
  $(document).on('click.profileSnapshotSubmit', '#profile_snapshot_form input[type="submit"]', function (e) {
    e.preventDefault()
    document.dispatchEvent(new Event('saveEditableText'))
    this.form.requestSubmit(this)
  })
}
